export default "__VITE_ASSET__N_XHAZ11__"